<script setup>
// Astra DS · Avatar — la cara de una persona, en pequeño.
//
// Figma `Avatar 64:2`, dentro de `Pattern/Voz 2543:13639` (entrega
// `2026-10-20-radio-voz-con-avatar.md`). Lo usa `Voz`, y nunca va solo: el
// avatar sin nombre no se entiende (Pablo, 20.10.26).
//
// 🔴 **Redondo**: excepción declarada al radio 0, solo para esta pieza (Pablo,
// 20.10.26, DESIGN.md § Radio · la voz lleva su avatar). Contorno de 1 en
// `border/default` por dentro y fondo `bg/subtle`. Sin foto, se queda el
// círculo; no se inventa una cara.
defineProps({
  src: { type: String, default: "" },
  alt: { type: String, default: "" },
  size: { type: Number, default: 24 },
});
</script>

<template>
  <span class="avatar" :style="{ '--lado': `${size}px` }">
    <img v-if="src" :src="src" :alt="alt" loading="lazy" />
  </span>
</template>

<style scoped lang="scss">
.avatar {
  position: relative;
  display: inline-block;
  flex: none;
  width: var(--lado);
  height: var(--lado);
  overflow: hidden;
  // La excepción: el único radio del sistema que no es 0.
  border-radius: 50%;
  background: var(--color-bg-subtle);

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  // El contorno por dentro, encima de la foto.
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 50%;
    box-shadow: inset 0 0 0 1px var(--color-border-default);
  }
}
</style>
